module.exports = __webpack_public_path__ + "static/media/logo-textured.e96e069c.svg";